class LicensesDetailViewController extends MUIViewController
{    
    static newInstance(): LicensesDetailViewController {
        let vc:LicensesDetailViewController;

        if (MIOCoreIsPhone() == true) {
            vc = new LicensesDetailViewController('licenses-detail-view_phone');
            vc.initWithResource('layout/licenses/LicensesDetailView_phone.html');                
        }
        else {
            vc = new LicensesDetailViewController('licenses-detail-view');
            vc.initWithResource('layout/licenses/LicensesDetailView.html');                    
        }

        return vc;
    }

    private segmentedControl:MUISegmentedControl = null;
    private pageController:MUIPageController = null;

    private stateComboBox:MUIComboBox = null;
    private addButton:MUIButton = null;
    private saveButton:MUIButton = null;
    private settingsButton:MUIButton = null;

    private licenseViewController:ApplicationLicenseDetailViewController = null;
    private invoiceViewController:LicenseInvoiceViewController = null;
    private paymentFeeViewController:BusinessLicensePaymentFeeViewController = null;

    private selectedIndex = 0;

    viewDidLoad(){
        super.viewDidLoad();

        this.segmentedControl = MUIOutlet(this, "segmented-control", "MUISegmentedControl");
        this.segmentedControl.setAction(this, function(this:LicensesDetailViewController, control:MUISegmentedControl, index:number){
            this.setPageIndex(index);
        });

        this.stateComboBox = MUIOutlet(this, "item-state-cb", "MUIComboBox");
        this.stateComboBox.setOnChangeAction(this, function(this:LicensesDetailViewController, control:MUIComboBox, value:string){
            this.licenseViewController.setStatusFilter(parseInt(value));
        });

        this.addButton = MUIOutlet(this, "add-btn", "MUIButton");
        this.addButton.setAction(this, function(this:LicensesDetailViewController){
            if (this.selectedIndex == 0) this.licenseViewController.showAddLicenseAction();
            else if (this.selectedIndex == 2) this.paymentFeeViewController.addPaymentFeeAction();
        });

        this.saveButton = MUIOutlet(this, "save-btn", "MUIButton");
        this.saveButton.setAction(this, function(){
            DBHelper.saveMainContext();
        });

        this.settingsButton = MUIOutlet(this, "settings-btn", "MUIButton");
        this.settingsButton.setAction(this, function(this:LicensesDetailViewController){
            this.licenseViewController.showSettingActions();
        });

        this.pageController = MUIOutlet(this, "page-controller", "MUIPageController");

        this.licenseViewController = ApplicationLicenseDetailViewController.newInstance();
        this.pageController.addPageViewController(this.licenseViewController);

        this.invoiceViewController = LicenseInvoiceViewController.newInstance();
        this.pageController.addPageViewController(this.invoiceViewController);

        this.paymentFeeViewController = BusinessLicensePaymentFeeViewController.newInstance();
        this.pageController.addPageViewController(this.paymentFeeViewController);

        this.setPageIndex(0);
    }

    viewWillAppear(animate?){
        super.viewWillAppear(animate);
        this.updateUI();
    }

    private businessLicense:BusinessLicense = null;
    set item(item:BusinessLicense) {
        this.businessLicense = item;
        this.updateUI();
    }

    private updateUI(){
        if(this.viewIsLoaded == false || this.businessLicense == null) return;

        this.licenseViewController.item = this.businessLicense;
        this.invoiceViewController.item = this.businessLicense;
        this.paymentFeeViewController.item = this.businessLicense;
    }

    private setPageIndex(index:number){
        this.selectedIndex = index;
        this.pageController.showPageAtIndex(index);

        this.stateComboBox.hidden = index != 0;
    }


}